// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"14cb0921","551":"c2ddb01f"}[chunkId] + ".chunk.js";
};